import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setPatientDetails } from "../reduxtool/action";
import { FaPlus } from "react-icons/fa";
import { LuPencil } from "react-icons/lu";
import profile from "../images/profile.svg";
import { IoCallOutline } from "react-icons/io5";
import { CiMail } from "react-icons/ci";
import { TextField } from "@mui/material";
import CryptoJS from "crypto-js";
import check from "../images/check.png";
import { decryptData } from "../Services/TabServices";

interface EditProfileProps {
  age: string;
  onClose: () => void;
  profileImage:string
}
  const EditProfile: React.FC<EditProfileProps> = ({ age, onClose,profileImage }) => {
  const storedUserId = sessionStorage.getItem("userId");
  const PatientId = storedUserId ? decryptData(storedUserId) : null;
  const token = sessionStorage.getItem("token");
  const fileInputRef = useRef<HTMLInputElement>(null);
  const dispatch: any = useDispatch();
  const patientProfile = useSelector((state: any) => state.userDetails);
  const [image, setImage] = useState<string | null>(null);
  const [patientImage, setPatientImage] = useState<string | null>(null);
  const [isMailEditing, setMailEditing] = useState<boolean>(false);
  const [isMobileEditing, setMobileEditing] = useState<|"editNumber"|"newNumber"|"SucessMessage"|"oldOTPSend"|"newMobileOTP"|null>(null);
  const [selectedMethod, setSelectedMethod] = useState<"number"|"mail"|null>(null);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [newOtpSend, setNewOtpSend] = useState<boolean>(false);
  const [encryptedOTP, setEncriptedOtp] = useState<any>("");
  const [formDataOtp, setFormDataOtp] = useState<any | null>({ otp: "" });
  const [error, setError] = useState<string | null>(null);
  const inputRefs = useRef<Array<HTMLInputElement | null>>([]);
  const [formDataNewNumber, setFormDataNewNumber] = useState<string>("");
  const [profileImageEdit, setProfileImageEdit] = useState<string | null>(profileImage || null);
  const [isImageEditing, setIsImageEditing] = useState<boolean>(false);

  const [formData, setFormData] = useState<any>({
    PatientId: PatientId,
    PatientProfileImage: patientImage,
    Email: "",
  });

  useEffect(() => {
    if (!patientProfile) {
      dispatch(setPatientDetails(token, PatientId));
    }
  }, [dispatch, token, PatientId, patientProfile]);

  const handleUpdateProfile = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormData((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const file: any = event.target.files[0];
      setPatientImage(file);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setImage(reader.result as string);
      };
    }
  };

  const handleEditClick = () => {
    setProfileImageEdit(null)
    fileInputRef.current?.click();
  };
  const handleSaveProfile = async()=>{
    const formDataToSend = new FormData();
    formDataToSend.append("PatientId", PatientId || "");
    formDataToSend.append("Email", formData.Email || "");
    if (patientImage){
      formDataToSend.append("PatientProfileImage", patientImage);
    }
    try{
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/Patient/UpdatePatientImage`,
        formDataToSend,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setMailEditing(false);
      dispatch(setPatientDetails(token, PatientId));
      onClose();
    } catch (error: any){
      console.error(
        "Error updating profile:",
        error.response?.data || error.message
      );
    }
  };

  const handleChange = (index: number, value: string) => {
    if (!/^\d?$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    setFormDataOtp((prev: any) => ({
      ...prev,
      otp: newOtp.join(""),
    }));
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (
    index: number,
    e: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handleSendVerificationNumber = async () => {
    try {
      const response: any = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/Patient/VerifiedMobileNumber?phoneNo=${patientProfile.phoneNo}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setEncriptedOtp(response.data.encryptedOtp);
      setSelectedMethod("number");
    } catch (error) {
      console.error("Error in sending OTP to the old mobile number", error);
    }
  };

  const handleSubmit = () => {
    const secretKey = "12345678912345698745632165498712";
    const EncryptionIV = "1234569874123659";

    decryptOtp(encryptedOTP, secretKey, EncryptionIV);
  };

  const decryptOtp = (
    encryptedOtp: string,
    secretKey: string,
    EncryptionIV: string
  ) => {
    try {
      const bytes = CryptoJS.AES.decrypt(
        encryptedOtp,
        CryptoJS.enc.Utf8.parse(secretKey),
        {
          iv: CryptoJS.enc.Utf8.parse(EncryptionIV),
        }
      );

      const otp = bytes.toString(CryptoJS.enc.Utf8);
      if (!otp) {
        throw new Error("Decryption resulted in an empty value");
      }
      if (otp === formDataOtp.otp) {
        setMobileEditing("newNumber");
        setError(null);
        setOtp(["", "", "", "", "", ""]);
      } else {
        setError("Invalid OTP. Please try again.");
      }
    } catch (error) {
      console.error("Decryption failed", error);
    }
  };

  const handleNewNumberChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = event.target;
    if (/^\d{0,10}$/.test(value)) {
      setFormDataNewNumber(value);
    }
  };

  const handleOtpVerification = () => {
    const secretKey = "12345678912345698745632165498712";
    const EncryptionIV = "1234569874123659";
    decryptNewOtp(encryptedOTP, secretKey, EncryptionIV);
  };

  const decryptNewOtp = (
    encryptedOtp: string,
    secretKey: string,
    EncryptionIV: string
  ) => {
    try {
      const bytes = CryptoJS.AES.decrypt(
        encryptedOtp,
        CryptoJS.enc.Utf8.parse(secretKey),
        {
          iv: CryptoJS.enc.Utf8.parse(EncryptionIV),
        }
      );

      const otp = bytes.toString(CryptoJS.enc.Utf8);
      if (!otp) {
        throw new Error("Decryption resulted in an empty value");
      }
      if (otp === formDataOtp.otp) {
        handleOtpVerificationApi();
        setError(null);
        setOtp(["", "", "", "", "", ""]);
      } else {
        setError("Invalid OTP. Please try again.");
      }
    } catch (error) {
      console.error("Decryption failed", error);
    }
  };
  const handleNewNumberOtpSend = async () => {
    try {
      const response: any = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/Patient/VerifiedMobileNumber?phoneNo=${formDataNewNumber}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setEncriptedOtp(response.data.encryptedOtp);
      setNewOtpSend(true);
    } catch (error) {
      console.error("Error in sending OTP to the old mobile number", error);
    }
  };
  // setSelectedMethod("number");
  const handleOtpVerificationApi = async () => {
    if (!formDataNewNumber && !patientProfile.phoneNo) {
      console.error(" No new phone number provided.");
      return;
    }

    try {
      const response: any = await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/api/Patient/UpdateMobileNo`,
        {
          oldPhoneNo: patientProfile.phoneNo,
          newPhoneNo: formDataNewNumber,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch(setPatientDetails(token, PatientId));
      setMobileEditing("SucessMessage");
      
    } catch (error: any) {
      console.error("Error inUpdate ", error);
      if (error.response?.status === 409) {
        setError("The new mobile number is already in use.");
        setMobileEditing("newNumber");
      }
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-20 flex justify-center items-center border z-50">
      <div className="rounded-xl shadow-lg shadow-gray-400 bg-[#F8F8F8] relative border w-full xs:w-[80%] sm:w-[60%] md:w-[60%] lg:w-[40%]">
        <button
          onClick={onClose}
          className="absolute top-1  right-1 h-5 w-5 text-sm z-20 text-white font-semibold p-1 rounded-full shadow-sm hover:bg-white hover:text-[#184A84] transition-all duration-300 flex items-center justify-center"
        >
          ✕
        </button>

        <div className={isMobileEditing ? "h-[470px]" : "h-[200px]"}>
          <div className=" text-center relative  pb-2">
            <div className="">
            <div className={`bg-[#184A84] w-full py-2 ${isMobileEditing ? "rounded-tl-xl rounded-tr-xl" : "rounded-xl"}`}>
            <div className="flex flex-row w-full p-2">
                  <div className="flex flex-col items-center xs:pt-5 xs:pb-2 border-r-2 border-white w-1/2">
                    <div className="relative w-24 h-24">
                 
                     
                     
                      {profileImageEdit ?(<img
                        src={`${process.env.REACT_APP_BASE_URL}${profileImageEdit }`}
                        alt={profile}
                        className="w-24 h-24 rounded-full bg-white p-1 object-cover"
                      />):(<img
                        src={image || profile}
                        alt={profile}
                        className="w-24 h-24 rounded-full bg-white p-1 object-cover"
                      />)}
                    
                      <button
                        className="absolute bottom-1 right-1 bg-black text-white text-xs p-1 rounded-full"
                        onClick={handleEditClick}
                      >
                        <FaPlus />
                      </button>
                    </div>
                    <input
                      type="file"
                      ref={fileInputRef}
                      accept="image/*"
                      className="hidden"
                      onChange={handleFileChange}
                    />
                    <h2 className="text-white text-lg font-semibold mt-2">
                      {patientProfile?.patientName}
                    </h2>
                    <p className="text-white text-sm">
                      {age} years
                    </p>
                  </div>

                  <div className="flex flex-col items-start xs:pt-5 xs:pb-2 px-5 w-1/2">
                    <div className="w-full mt-8">
                      <div className="flex items-center justify-between gap-2 px-4 py-2 bg-[#FCFFFF40] rounded-full shadow-md">
                        <p className="text-white font-medium text-sm">
                          {patientProfile?.phoneNo}
                        </p>
                        <button
                          onClick={() => setMobileEditing("editNumber")}
                          className="cursor-pointer bg-white p-1 rounded-full shadow-md"
                        >
                          <LuPencil className="text-black text-sm" />
                        </button>
                      </div>
                    </div>

                    {/* Email */}
                    <div className="w-full mt-4">
                      <div className="flex items-center justify-between gap-2 px-4 py-2 bg-[#FCFFFF40] rounded-full shadow-md">
                        {isMailEditing || !patientProfile?.email ? (
                          <input
                            type="text"
                            name="Email"
                            placeholder="Enter your email"
                            value={formData.Email}
                            onChange={handleUpdateProfile}
                            className="border focus:outline-none px-2 text-sm text-gray-700 w-full rounded-lg shadow-sm"
                          />
                        ) : (
                          <div className="flex items-center justify-between gap-2 w-full">
                            <p className="text-white font-medium text-sm truncate">
                              {patientProfile?.email}
                            </p>
                            <button
                              onClick={() => setMailEditing(true)}
                              className="cursor-pointer bg-white p-1 rounded-full shadow-md"
                            >
                              <LuPencil className="text-black text-sm" />
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex justify-center items-center mt-2 ">
                  <button
                    onClick={handleSaveProfile}
                    className="px-3  w-[40%] py-1 bg-white text-[#184A84] font-semibold rounded-lg text-[12px] mb-2 mt-2"
                  >
                    Save
                  </button>
                </div>
              </div>

              {isMobileEditing == "editNumber" && (
                <div className="flex justify-center ">
                  <div className="text-start mt-10 p-5 w-[75%] bg-[#F5F5F5]  border mb-5  rounded-lg mb-5 border">
                    <p className="font-semibold">Verification</p>
                    <div className="flex justify-around mt-3">
                      <p
                        className={`text-center p-1 text-xs w-[45%] rounded-full font-semibold cursor-pointer transition-all duration-300
              ${
                selectedMethod === "number"
                  ? "text-black border-[1px] border-[#005f50] shadow-sm shadow-gray-400"
                  : " text-black bg-white"
              }
          `}
                        onClick={() => {
                          handleSendVerificationNumber();
                          setMobileEditing("oldOTPSend");
                        }}
                      >
                        Verify by Number
                      </p>
                      <p
                        className={`text-center p-1 text-xs w-[45%] rounded-full font-semibold cursor-pointer transition-all duration-300
            ${
              selectedMethod === "mail"
                ? "bg-[#007a68] text-white border-[1px]  border-[#005f50]"
                : "bg-white"
            }
          `}
                        onClick={() => setSelectedMethod("mail")}
                      >
                        Verify by Mail
                      </p>
                    </div>

                    {error && (
                      <>
                        <p>{error}</p>
                      </>
                    )}
                  </div>
                </div>
              )}

              {isMobileEditing == "oldOTPSend" && (
                <div className="flex justify-center ">
                  <div className="flex  flex-col mt-5 p-5 w-[90%] xs:w-[75%] bg-[#F5F5F5]  border mb-5 rounded-lg  ">
                    <p className=" text-start text-sm font-medium mb-2">
                      Enter the 6-digit OTP sent to your{" "}
                      {selectedMethod === "number" ? "mobile number" : "email"}:
                    </p>
                    <div className="flex gap-2 mt-2">
                      {otp.map((digit, index) => (
                        <input
                          key={index}
                          ref={(el) => {
                            inputRefs.current[index] = el;
                          }}
                          type="text"
                          maxLength={1}
                          value={digit}
                          onChange={(e) => handleChange(index, e.target.value)}
                          onKeyDown={(e) => handleKeyDown(index, e)}
                          className="w-6 h-8 text-sm font-semibold text-[#009A85] text-center bg-[#009A8526]  border-2 border-[#009A85] rounded-lg focus:outline-none "
                        />
                      ))}
                    </div>
                    <div
                      className=" px-3  text-center  py-1 bg-[#009A85] text-white rounded-lg text-[14px] mt-5"
                      onClick={handleSubmit}
                    >
                      <button>Verify Now</button>
                    </div>
                  </div>
                </div>
              )}

              {isMobileEditing == "newNumber" && (
                <div className="flex justify-center ">
                  <div className="text-start  mt-10 p-5 w-[90%] xs:w-[75%] bg-[#F5F5F5]  border mb-5  border rounded-lg">
                    <p className="font-semibold">Update new mobile number </p>
                    <div className="flex flex-row justify-around gap-2 xs:gap-5 mt-3 w-full">
                      <input
                        type="text"
                        maxLength={10}
                        value={formDataNewNumber}
                        onChange={handleNewNumberChange}
                        className="border border-gray-300  rounded-lg text-center text-sm p-1 focus:outline-none"
                        placeholder="Enter Mobile Number"
                      />

                      <button
                        className="  bg-[#009A85] w-[40%] rounded-full text-white  m-[2px]"
                        onClick={() => {
                          handleNewNumberOtpSend();
                          setMobileEditing("newMobileOTP");
                        }}
                      >
                        send OTP
                      </button>
                    </div>
                    {error && <div className="text-red-500 text-[12px] mt-2">{error}</div>}
                  </div>
                </div>
              )}

              {isMobileEditing === "newMobileOTP" && newOtpSend && (
                <div className="flex justify-center w-full">
                  <div className=" mt-7 p-5 w-[90%] xs:w-[75%] bg-[#F5F5F5]  border mb-5  border rounded-lg">
                    <div className="flex flex-col mt-5">
                      <p className="text-start text-sm font-medium mb-2">
                        Enter the 6-digit OTP sent to your number
                      </p>
                      <div className="flex gap-2">
                        {otp.map((digit, index) => (
                          <input
                            key={index}
                            ref={(el) => {
                              inputRefs.current[index] = el;
                            }}
                            type="text"
                            maxLength={1}
                            value={digit}
                            onChange={(e) =>
                              handleChange(index, e.target.value)
                            }
                            onKeyDown={(e) => handleKeyDown(index, e)}
                            className="w-6 h-8 text-sm font-semibold text-[#009A85] text-center bg-[#009A8526] border-2 border-[#009A85] rounded-lg focus:outline-none "
                          />
                        ))}
                      </div>
                    </div>

             
                    <div
                      className=" px-3  text-center  py-1 bg-[#009A85] text-white rounded-lg text-[14px] mt-3"
                      onClick={handleOtpVerification}
                    >
                      <button>Verify Now</button>
                    </div>
                  </div>
                </div>
              )}

              {isMobileEditing == "SucessMessage" && (
                <div className="flex justify-center items-center mt-5 ">
                  <div className="text-start mt-10 p-5 w-[90%] xs:w-[70%] bg-[#F5F5F5] mb-5 border rounded-lg">
                    <div>
                      <div className="flex  justify-center mb-2 ">
                        <img
                          src={check}
                          alt=""
                          className="text-center w-6 h-6"
                        />
                      </div>
                      <p className="text-center font-semibold text-sm">
                        Your Number has been updated
                      </p>
                      <p className="text-center text-xs text-[#606060] mt-1">
                        you can change it further if needed
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EditProfile;
